import { MatDialog } from '@angular/material/dialog';
import { AiAssistantDialogComponent } from 'src/app/core/components/ai-assistant/ai-assistant-dialog/ai-assistant-dialog.component';

export function isAiAssistantDialogOpen(dialog: MatDialog): boolean {
  return dialog.openDialogs.some(
    (d) => d.componentInstance instanceof AiAssistantDialogComponent
  );
}
